import React from 'react'
import I18N from './i18n'
import { ToastProvider } from './base/toast'
import { getLocaleOnServer } from '@/i18n/server'
import { Locale } from '@/i18n'

export type II18NServerProps = {
  children: (locale: Locale) => React.ReactNode
}

const I18NServer = ({ children }: II18NServerProps) => {
  const locale = getLocaleOnServer()
  return (
    <I18N {...{ locale }}>
      <ToastProvider>{children(locale)}</ToastProvider>
    </I18N>
  )
}

export default I18NServer
